import palette from '../../palette';
import typography from "../../typography";

export default {
  root: {
    fontSize: "16px",
    fontWeight: typography.fontWeightLight,
    color: palette.grayText,
    "&$contained" : {
      marginLeft: "0px",
    },
    "&$error": {
      color: palette.redError,
    },
    ['@media (max-width: 768px)']: {
      marginTop: "5px",
      fontSize: "14px",
    },
  },
};